exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".i-TSNMq-df80Nf{width:650px}", ""]);

// exports
exports.locals = {
	"shortcutsPage": "i-TSNMq-df80Nf"
};